import Select from 'react-select'
import CreatableSortableSelect from 'Shared/components/CreatableSortableSelect'
import './TextMatchInput.scoped.scss'

const OPERATOR_OPTIONS = [
  { value: 'is', label: 'is' },
  { value: 'is_any_of', label: 'is any of' },
  { value: 'contains', label: 'contains' },
  { value: 'contains_any_of', label: 'contains any of' },
  { value: 'starts_with', label: 'starts with' },
  { value: 'ends_with', label: 'ends with' },
  { value: 'present', label: 'has value' },
  { value: 'empty', label: 'is empty' },
]

const OPERATORS_WITHOUT_VALUE = ['present', 'empty']
const MULTI_VALUE_OPERATORS = ['is_any_of', 'contains_any_of']
const MAX_VALUES = 200
const PASTE_DELIMITERS = /[,\t]+/

export default function TextMatchInput({ value, onChange }) {
  const safeValue = value && typeof value === 'object' ? value : { operator: 'contains', value: '' }
  const operator = safeValue.operator || 'contains'
  const isMulti = MULTI_VALUE_OPERATORS.includes(operator)
  const needsValue = !OPERATORS_WITHOUT_VALUE.includes(operator) && !isMulti

  function handleOperatorChange(option) {
    if (OPERATORS_WITHOUT_VALUE.includes(option.value)) {
      onChange({ operator: option.value })
    } else if (MULTI_VALUE_OPERATORS.includes(option.value)) {
      onChange({ operator: option.value, values: Array.isArray(safeValue.values) ? safeValue.values : [] })
    } else {
      onChange({ operator: option.value, value: safeValue.value || '' })
    }
  }

  const values: string[] = Array.isArray(safeValue.values) ? safeValue.values : []
  const selectValue = values.map((v) => ({ label: v, value: v }))
  const limitReached = values.length >= MAX_VALUES

  function handleMultiChange(newOptions) {
    const next = (newOptions || []).map((o) => o.value).slice(0, MAX_VALUES)
    onChange({ operator, values: next })
  }

  return (
    <div className="text-match-input">
      <div className="text-match-operator">
        <Select
          options={OPERATOR_OPTIONS}
          value={_.find(OPERATOR_OPTIONS, { value: operator })}
          onChange={handleOperatorChange}
        />
      </div>
      {needsValue && (
        <input
          type="text"
          value={safeValue.value || ''}
          onChange={(e) => onChange({ ...safeValue, value: e.target.value })}
        />
      )}
      {isMulti && (
        <div className="text-match-multi">
          <CreatableSortableSelect
            value={selectValue}
            onChange={handleMultiChange}
            placeholder="Type, paste a list, or press Enter…"
            splitDelimiters={PASTE_DELIMITERS}
            maxValues={MAX_VALUES}
            isValidNewOption={(input, _selected, current) => {
              if (!input || !input.trim()) return false
              if ((current || []).length >= MAX_VALUES) return false
              return !(current || []).some((o) => o.value === input.trim())
            }}
            formatCreateLabel={(input) => `Add "${input}"`}
          />
          {limitReached && (
            <div className="text-match-multi-hint">Maximum of {MAX_VALUES} values reached</div>
          )}
        </div>
      )}
    </div>
  )
}
